export default {
  container: {
    textAlign: 'center',
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'lightblue',
    height: '100vh',
  },
  email: {
  },
  password: {
  },
  main: {
    margin: 5,
    flex: 1,
  },
  row: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  profile: {
    margin: 5,
    padding: 5,
  },
};



// WEBPACK FOOTER //
// ./src/components/Authentication/ProfileDialog/styles.js